import { MutationTree } from 'vuex';
import { PrivilegedIdSettingState, PrivilegedIdSetting } from './types';
import * as types from './mutation-types';
import { ErrorDetail } from '../../types';

export const mutations: MutationTree<PrivilegedIdSettingState> = {
    // 特権ID管理設定取得系
    [types.SHOW_START](state) {
        const showState = state.show;
        showState.error = false;
        showState.errorCode = undefined;
        showState.errorMsg = undefined;
        showState.isProcessing = true;
        showState.isFetchSuccess = false;
    },

    [types.SHOW_SUCCESS](state, payload: { privilegedIdSetting: PrivilegedIdSetting }) {
        state.privilegedIdSetting = payload.privilegedIdSetting;

        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = true;
    },

    [types.SHOW_FAILURE](state, payload: { code: string; message: string }) {
        const showState = state.show;
        showState.errorCode = payload.code;
        showState.errorMsg = payload.message;
        showState.error = true;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;
    },

    // 特権ID管理設定更新系
    [types.UPDATE_START](state, category) {
        const updateState = state.update;
        updateState.error = false;
        updateState.errorTitle = undefined;
        updateState.errorDetails = undefined;
        updateState.isProcessing = true;
        updateState.category = category;
    },

    [types.UPDATE_SUCCESS](state) {
        const updateState = state.update;
        updateState.isProcessing = false;
        updateState.category = undefined;
    },

    [types.UPDATE_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const updateState = state.update;
        updateState.errorTitle = payload.errorTitle;
        updateState.errorDetails = payload.errorDetails;
        updateState.error = true;
        updateState.isProcessing = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;

        const updateState = state.update;
        updateState.isProcessing = false;
    },

    [types.CLEAR_ALL](state) {
        state.privilegedIdSetting = undefined;
        state.show.isProcessing = false;
        state.show.isFetchSuccess = false;
        state.show.error = false;
        state.show.errorCode = undefined;
        state.show.errorMsg = undefined;
        state.update.isProcessing = false;
        state.update.error = false;
        state.update.errorTitle = undefined;
        state.update.errorDetails = undefined;
        state.update.category = undefined;
    },
};
